import { cn } from "@/lib/utils";

export const TitleHeader = ({
  white,
  smallTitle,
  largeTitle,
}: {
  white?: boolean;
  smallTitle: string;
  largeTitle: string;
}) => {
  return (
    <div className={cn(`flex flex-col gap-2.5`)}>
      <h3
        className={cn(
          "color-[#151c29] text-center font-medium",
          white && "text-white",
        )}
      >
        {smallTitle}
      </h3>
      <h2
        className={cn(
          "color-[#151c29] text-center text-5xl font-bold",
          white && "text-white",
        )}
      >
        {largeTitle}
      </h2>
    </div>
  );
};
